import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FieldMap, isRule, isRuleSet, Rule, RuleSet} from "../../../_typing/query-builder";
import {deepCopy} from "../../../lib/utils";
import {QueryBuilderFormService} from "../../../services/query-builder-form.service";
import {take} from "rxjs/operators";
import {FormsModule} from "@angular/forms";
import {WireRuleComponent} from "../rule/wire-rule.component";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {MatButton} from "@angular/material/button";
import {BaseComponent} from "../../../shared/base.component";


@Component({
    selector: 'wire-rule-set',
    templateUrl: './wire-rule-set.component.html',
    imports: [
        FormsModule,
        WireRuleComponent,
        MatButtonToggleGroup,
        MatButtonToggle,
        MatButton
    ],
    styleUrls: ['./wire-rule-set.component.scss']
})
export class WireRuleSetComponent extends BaseComponent {
    @Input() ruleSet: RuleSet;
    @Input() readonly fields: FieldMap;
    defaultRule: Rule;
    @Input() allowRemoveRuleSet: boolean = true;
    @Input() isQueryBuilder: boolean = true;
    @Output() ruleSetChange: EventEmitter<RuleSet> = new EventEmitter<RuleSet>();
    @Output() removeRuleSetRequest = new EventEmitter();
    isTopLevel:boolean = false;
    isRule = isRule;
    isRuleSet = isRuleSet;

    constructor(private queryBuilderFormService: QueryBuilderFormService) {
        super();
        this.queryBuilderFormService.defaultRuleChanged.pipe(take(1))
            .subscribe(rule => {
                this.defaultRule = rule;
            });
    }

    override ngOnInit() {
        super.ngOnInit();
        this.isTopLevel = !this.allowRemoveRuleSet;
    }

    addRuleSet(): void {
        const ruleSet = new RuleSet();
        ruleSet.rules.push(deepCopy(this.defaultRule));
        this.ruleSet.rules.push(ruleSet);
        this.ruleSetChanged();
    }

    addRule(): void {
        this.ruleSet.rules.push(deepCopy(this.defaultRule));
        this.ruleSetChanged();
    }

    removeRuleSet(i: number): void {
        this.ruleSet.rules.splice(i, 1);
        this.ruleSetChanged();
    }

    removeRule(i: number): void {
        this.ruleSet.rules.splice(i, 1);
        this.ruleSetChanged();
    }

    ruleSetChanged($event?: RuleSet, i?: number): void {
        if ($event) {
            this.ruleSet.rules[i] = $event;
        }
        this.ruleSetChange.next(this.ruleSet);
    }

    requestRemoveRuleSet(): void {
        this.removeRuleSetRequest.emit();
    }
}
